import { render, staticRenderFns } from "./InvoiceCopyModal.vue?vue&type=template&id=3cb52897&"
import script from "./InvoiceCopyModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceCopyModal.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCopyModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports